export default function Hero() {
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section className="relative pt-[20px] pb-[80px] md:pt-[160px] md:pb-[120px]">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://storage.readdy-site.link/project_files/2c8dff40-da10-4319-8749-b28a3c9ab9ef/d641043d-6b4a-48f3-905e-f893192587e2_Hero-Image.jpg?v=57e31bdb8b55da269c999cddc0098cb1"
          alt="Healthcare network visualization"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/55" />
      </div>

      {/* Content */}
      <div className="relative w-full max-w-[1120px] mx-auto px-5 md:px-10">

        {/* Primary Headline */}
        <h1 className="text-[32px] sm:text-[42px] md:text-[51px] font-semibold text-white tracking-[-0.025em] leading-[1.1] mb-5 max-w-[680px]">
          Building the Next Exceptional Healthcare Platform
        </h1>

        {/* Body Copy */}
        <p className="text-[15px] md:text-[17px] leading-[1.7] text-white/90 max-w-[480px] mb-8">
          Valaxis Group is a CEO-led acquisition initiative focused on acquiring and scaling a healthcare, pharma services or technology-enabled services business in partnership with long-term investors.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row flex-wrap gap-3">
          <button
            onClick={() => scrollTo('contact')}
            className="text-[#1E2430] text-[15px] font-medium hover:opacity-90 transition-opacity duration-200 cursor-pointer whitespace-nowrap h-[46px] px-8 bg-white rounded-[9px] border-none"
          >
            Start a Conversation
          </button>
          <button
            onClick={() => scrollTo('investment-focus')}
            className="text-white text-[15px] font-medium hover:bg-white/20 transition-colors duration-200 cursor-pointer whitespace-nowrap h-[46px] px-8 bg-white/12 rounded-[9px] border border-white/35"
          >
            Investment Thesis
          </button>
          <button
            onClick={() => scrollTo('founder')}
            className="text-white text-[15px] font-medium hover:bg-white/20 transition-colors duration-200 cursor-pointer whitespace-nowrap h-[46px] px-8 bg-white/12 rounded-[9px] border border-white/35"
          >
            About the Operator
          </button>
        </div>

        {/* Trust Indicators */}
        <div className="flex flex-wrap items-center gap-6 md:gap-10 mt-12 md:mt-14">
          <div>
            <p className="text-[24px] md:text-[28px] font-semibold text-white leading-none mb-1">20+</p>
            <p className="text-[11px] md:text-[12px] font-medium tracking-[0.08em] uppercase text-white/70">Years Experience</p>
          </div>
          <div className="w-px h-9 bg-white/20 hidden sm:block" />
          <div>
            <p className="text-[24px] md:text-[28px] font-semibold text-white leading-none mb-1">CEO</p>
            <p className="text-[11px] md:text-[12px] font-medium tracking-[0.08em] uppercase text-white/70">Operator-Led</p>
          </div>
          <div className="w-px h-9 bg-white/20 hidden sm:block" />
          <div>
            <p className="text-[24px] md:text-[28px] font-semibold text-white leading-none mb-1">Long-Term</p>
            <p className="text-[11px] md:text-[12px] font-medium tracking-[0.08em] uppercase text-white/70">Value Creation</p>
          </div>
        </div>
      </div>
    </section>
  );
}
